import { dispatchTrackingEvent, TrackingEvents, type TrackingEventsAdditionalData } from "@jti/tracker";

export const CONSENT_REMINDER_GTM_LOCATION = "consent-reminder-dialog";

export type ConsentReminderCloseReason =
  TrackingEventsAdditionalData[TrackingEvents.TrackingPopinClose]["close_reason"];

export const trackConsentReminderCtaClick = (ctaName: string) => {
  return dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
    cta_name: ctaName,
    cta_location: CONSENT_REMINDER_GTM_LOCATION,
  });
};

export const trackConsentReminderClose = (closeReason: ConsentReminderCloseReason, popinName: string) => {
  return dispatchTrackingEvent(TrackingEvents.TrackingPopinClose, {
    close_reason: closeReason,
    popin_location: CONSENT_REMINDER_GTM_LOCATION,
    popin_name: popinName,
  });
};
